const githubLink = "https://github.com/jigardeveloper";
const instaLink =
  "https://www.instagram.com/_jigar__ahir_/?igshid=ZGUzMzM3NWJiOQ";
const linkedInLink = "https://www.linkedin.com/in/jigar-ahir-335073202/";
const twitterLink = "https://twitter.com/";
const emailLink = "mailto:jigarahir147@gmail.com";

const profileLinks = {
  githubLink,
  instaLink,
  linkedInLink,
  twitterLink,
  emailLink,
};
const SocialData = profileLinks;
export default SocialData;
